/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleProductFromJSON, ApiSimpleProductToJSON, } from './ApiSimpleProduct';
export function ApiListSubscriptionProductsResponseFromJSON(json) {
    return ApiListSubscriptionProductsResponseFromJSONTyped(json, false);
}
export function ApiListSubscriptionProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': !exists(json, 'result') ? undefined : (json['result'].map(ApiSimpleProductFromJSON)),
    };
}
export function ApiListSubscriptionProductsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': value.result === undefined ? undefined : (value.result.map(ApiSimpleProductToJSON)),
    };
}
